export default "__VITE_ASSET__gtGiZFVS__"